import { useEffect, useState } from "react";
import { IMinerInstallDateProps } from "./MinerInstallDate.props";
import { useMinerContext } from "@components/Pages/Machines/MinerRow/MinerContext";
import { useAuth } from "@utils/hooks/useAuth";
import { MinerActions } from "@components/Pages/Machines/MinerRow/minerReducer";
import {
  AdminChangeDataSettingsRequest,
  AdminChangeSettingsRequest,
} from "@services/changeMinerSettings";
import useApiRequests from "@services/http/useApiRequest";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";
import { makeNotifs } from "@utils/makeNotifs";
import { MyFormMinerSettings } from "../../../MyForm";
import dayjs from "dayjs";

const FORMAT = "DD-MM-YYYY";

export const useMinerInstallDateControl = (props: IMinerInstallDateProps) => {
  const auth = useAuth();
  const { miner, dispatchMiner } = useMinerContext();
  const { onSuccess } = useGlobalNotifs();
  const { ok } = makeNotifs();
  const { enqueue } = useApiRequests();
  const [loading, setLoading] = useState(false);

  const onGetDate = async (date: number) => {

    const res = await enqueue(
      new AdminChangeSettingsRequest({
        miner: miner.id.toString(),
        set_install_time: dayjs(date).format("DD-MM-YYYY").toString(),
      }),
      { onLoadingStatusChanged: setLoading }
    );
    if (!res) return;
    dispatchMiner({
      type: MinerActions.InstallationDate,
      payload: dayjs(Number(date) / 1000)
        .valueOf()
        .toString(),
    });
    onSuccess(ok.success);
  };

  return {
    FORMAT,
    isAdmin: auth.isAdmin,
    loading,
    miner,

    onGetDate,
  };
};
